import $vuetify from 'vuetify/es5/locale/pt';

export default {
  $vuetify,
  search: 'Pesquisar',
  general: {
    close: 'Fechar',
    download: 'Baixar',
  },
  dashboard: {
    myTransactions: 'Minhas Transações',
    period: 'Período',
    last: 'Últimos',
    days: 'Dias',
    downloaded: 'Recebidos',
    uploaded: 'Enviados',
  },
  myusers: {
    users: 'Usuários',
    firstName: 'Nome',
    username: 'Username',
    email: 'Email',
  },
  mytransactions: {
    mytransactions: 'Minhas Transações',
  },
  transactions: {
    transactions: 'Transações',
  },
  transactionshelper: {
    title: 'Ajuda de Transação',
    timeline: {
      title: 'Timeline',
      subtitle: 'Exibe a timeline da transação',
    },
    create: {
      title: 'Criado',
      subtitle: 'Data da criação da transação',
    },
    enable: {
      title: 'Liberado',
      subtitle: 'Data da liberação da transação',
    },
    view: {
      title: 'Visualizado',
      subtitle: 'Usuário(s) que viram a transação',
    },
    receive: {
      title: 'Recebido',
      subtitle: 'Usuário(s) que receberam a transação',
    },
    use: {
      title: 'Usado',
      subtitle: 'Usuário(s) que usaram a transação',
    },
    close: 'Fechar',
  },
  transactionslist: {
    noDataText: 'Nenhum registro correspondente encontrado',
    rowsPerPageText: 'Linhas por página',
    startOfTransaction: 'Criado',
    waitingToBeSent: 'Esperando',
    endOfTransaction: 'Liberado',
    clone: 'Clonar a Transação',
    download: 'Download da Transação',
    timeline: {
      timeline: 'Linha do Tempo',
      create: 'Criado',
      enable: 'Liberado',
    },
    slots: {
      waiting: 'Esperando',
      notSuported: 'Não suportado',
      users: 'usuários',
      releasedIn: 'Liberado em',
      startOfTransaction: 'Criado',
      endOfTransaction: 'Liberado',
      waitingToBeSent: 'Aguardando Envio',
      seenBy: 'Visto por',
      receivedBy: 'Recebido por',
      usedBy: 'Utilizado por',
    },
  },
  metadata: {
    metadata: 'Metadados',
    noDataText: 'Menhum metadado encontrado.',
    table: {
      name: 'Nome',
      sequence: 'Sequência',
      type: 'Tipo',
      defaultValue: 'Valor Padrão',
      format: 'Fomato',
      primaryKey: 'Chave Primária',
    },
  },
  data: {
    data: 'Modelo',
  },
  mycompanies: {
    mycompanies: 'Empresas',
    tradingName: 'Nome',
    cnpj: 'CNPJ',
  },
};
